import * as React from "react";
function SvgAsterisk(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M16 1v30M1 16h30M5.39 5.39l21.22 21.22M5.39 26.61L26.61 5.39"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgAsterisk);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
